"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames = function () {
    var options = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        options[_i] = arguments[_i];
    }
    return options.reduce(function (classes, option) {
        if (!option) {
            return classes;
        }
        if (typeof option === "string") {
            return __spreadArrays(classes, [option]);
        }
        if (typeof option === "object") {
            return classes.concat(Object.keys(option).filter(function (key) { return option[key]; }));
        }
        return classes;
    }, []).join(" ");
};
exports.default = classnames;
